import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules Material utilises
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// Autres modules externes utilises 

// Modules communs utilises
import { BootstrapPopupModule } from '../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';
import { PannelModule } from '../../shared/pannel/pannel.module';
import { AntenneModule } from '../../data-domains/structure/antenne/antenne.module';
import { AgenceModule } from '../../data-domains/structure/agence/agence.module';
import { SousParcModule } from '../../data-domains/structure/sous-parc/sous-parc.module';
import { ParcModule } from '../../data-domains/structure/parc/parc.module';
import { OuvrageModule } from '../../data-domains/structure/ouvrage/ouvrage.module';
import { SuggestableInputModule } from '../../shared/suggestable-input/suggestable-input.module';
import { StaticTypesModule } from '../../static-types/static-types.module';

// Composants metiers
import { MemosComponent } from './components/memos.component';
import { MemosTableComponent } from './components/memos-table.component';
import { MemosFiltersComponent } from './components/memos-filters.component';
import { EditMemoDialogComponent } from './components/edit-memo-dialog.component';
import { FiltreGeographiqueComponent } from '../../data-domains/structure/transverse/components/filtre-geographique.component';

// Services metier
import { MemoService } from './services/memo.service';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,

		MatPaginatorModule,
		MatProgressBarModule,
		MatSortModule,
		MatTableModule,

		BootstrapPopupModule,
		CheckboxListModule,
		FilterableSelectModule,
		JSR310LocalDatesModule,
		ParcModule,
		AgenceModule,
		AntenneModule,
		SousParcModule,
		PannelModule,
		OuvrageModule,
		StaticTypesModule,
		SuggestableInputModule,
	],
	providers: [
		MemoService,
	],
	declarations: [
		MemosComponent,
		EditMemoDialogComponent,
		MemosTableComponent,
		MemosFiltersComponent,
		FiltreGeographiqueComponent,
	],
	exports: [
		EditMemoDialogComponent
	]
})
export class MemoModule {
	constructor() { }
}